import Vue from 'vue'
import Vuex from 'vuex'
import requestHTAPI from '@/axios/HantangTax'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    // 当前登录用户信息（mineInfo 接口返回）
    userInfo: null
  },
  mutations: {
    SET_USER_INFO (state, info) {
      state.userInfo = info
    }
  },
  actions: {
    // 获取用户信息（带缓存，避免重复请求；登录失效时缓存可能过期，可手动清除）
    fetchUserInfo ({ commit, state }) {
      if (state.userInfo) {
        return Promise.resolve(state.userInfo)
      }
      const formData = new FormData()
      formData.append('merId', localStorage.getItem('MERNO'))
      return requestHTAPI.mineInfo(formData).then(res => {
        console.log('mineInfo 响应', res.data)
        if (res.data.code === '0000') {
          commit('SET_USER_INFO', res.data.data || {})
          return res.data.data
        }
        return Promise.reject(res.data)
      })
    },
    // 清除用户信息缓存（退出登录或需要刷新时调用）
    clearUserInfo ({ commit }) {
      commit('SET_USER_INFO', null)
    }
  }
})
